export default __webpack_public_path__ + "static/media/Glittering_Ashes_LE.73160121.jpg";